module.exports = __webpack_public_path__ + "static/img/skyline@3x.e46c9d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3x/skyline@3x.png
// module id = lfIn
// module chunks = 1